export default {
	name: "LitRes",
	format: "mp3",
	connection: "ftp",
	audio: true,
	cover: true,
	meta: { format: "excel", fields: ["takedown"], sharedFields: ["tags", "thema"] },
	disableArticles: ["cd", "mp3cd"],
};
